import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'textSearchHighlight'
})
export class TextSearchHighlightPipe implements PipeTransform {
  transform(value: string, searchTerm?: string): string {
    if (value && searchTerm && searchTerm.length) {
      const matches = value.match(new RegExp(this.escape(searchTerm), 'gi'));
      let highlightedValue = value;
      if (matches) {
        matches.forEach((match) => {
          highlightedValue = value.replace(new RegExp(this.escape(match), 'g'), `<strong>${match}</strong>`);
        });
        return highlightedValue;
      }
    }
    return value;
  }

  private escape(input: string): string {
    return input.replace(/[.*+?^${}()|[\]\\\/]/g, '\\$&');
  }
}
